import { combineReducers } from 'redux'
import {
  createRequestReducer,
  createReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizeAssessments = data => {
  const assessment = new schema.Entity('assessments')
  return normalize(data, [assessment])
}

const AssessmentsReducer = combineReducers({
  fetchAssessmentsRequest: createRequestReducer('ASSESSMENT_STORE:FETCH'),
  deletingAssessmentRequests: createMappedRequestReducer(
    'ASSESSMENT_STORE:DELETE'
  ),
  assessments: createReducer(null, {
    'ASSESSMENT_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeAssessments(response.data.account.student_type.assessment_files),
    'ASSESSMENT_STORE:DELETE_REQUEST_SUCCESS': (state, { params }) => {
      const assessments = { ...state.entities.assessments }
      delete assessments[params.id]
      return {
        entities: { assessments },
        result: state.result.filter(id => id !== params.id)
      }
    }
  }),
  createAssessmentDialog: createReducer(
    { opened: false, selectedAssessments: [] },
    {
      'ASSESSMENT_STORE:CREATE_ASSESSMENT_DIALOG:OPEN': (
        state,
        { params }
      ) => ({
        ...state,
        opened: true,
        selectedAssessments: params.selectedAssessments
      }),
      'ASSESSMENT_STORE:CREATE_ASSESSMENT_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  ),
  invitationAssessmentDialog: createReducer(
    { opened: false },
    {
      'ASSESSMENT_STORE:INVITATION_ASSESSMENT_DIALOG:OPEN': (
        state,
        { params }
      ) => ({
        ...state,
        opened: true,
        id: params.id
      }),
      'ASSESSMENT_STORE:INVITATION_ASSESSMENT_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  )
})

export default AssessmentsReducer
